/* eslint-disable max-len */

export default {
  checkoutYourDetails: '05122016-170742-3634',
  // form labels
  firstNameLabel: '12022016-112206-6359',
  lastNameLabel: '12022016-112249-9745',
  countryLabel: '12022016-113406-4210',
  telephoneLabel: '24112016-105438-1638',
  countyRegionLabel: '22022019-142905-0022',
  companyNameLabel: '21112016-095337-5400',
  VATnumberLabel: '06122016-141440-8380',
  addressLine1Label: '12022016-113146-4215',
  addressLine2Label: '12022016-113221-6882',
  addressLine3Label: '12022016-113250-3273',
  addressExtra: '25032024-131937-0007', // Apartment, unit, suite, street, floor #
  enterAnAddress: '25032024-131937-0003',
  cantSeeAddress: '25032024-131937-0004',
  inputManually: '25032024-131937-0005',
  townCityLabel: '19122018-152801-0037',
  postcodeLabel: '12022016-113436-0026',
  continuetoPaymentButtonLabel: '19122018-152801-0039',
  continue: '22112016-144517-2631',
  registrationNumberLabel: '25072023-151819-0005',
  CUINumberLabel: '28112024-114230-2908',
  CNPNumberLabel: '28112024-114413-6557',

  // existedEmailModal
  existedEmailModalParagraph1: '19122018-152801-0075',
  existedEmailModalLoginButtonLabel: '22022019-142905-0024',

  // existedUnconfirmedEmailModal
  existedUnconfirmedEmailModalParagraph1: '24012019-150854-8569',
  existedUnconfirmedEmailModalParagraph2: '24012019-150953-4693',
  pleaseSelectCountry: '02042019-142619-0002',
  pleaseSelectRegion: '02042019-142619-0003',
  cardBillingAddress: '11112020-141916-0002',

  egyptCompanyFiscalStatus: '10112021-105223-0007',
  egyptPrivatePersonFiscalStatus: '10112021-105223-0008',

  turkishCompanyFiscalStatus: '10032021-154248-8747',
  turkishPrivatePersonFiscalStatus: '10032021-154316-7294',

  portugueseCompanyFiscalStatus: '27092022-084922-5483',
  portuguesePrivatePersonFiscalStatus: '27092022-085123-4381',
  portugueseForeignCompanyRegisteredWithinEUFiscalStatus: '27092022-085339-3409',

  mexicoCompanyFiscalStatus: '26082022-074816-0000',
  mexicoPrivatePersonFiscalStatus: '26082022-074816-0001',
  mexicoForeignStatus: '26082022-074816-0002',

  ugandaDomesticCustomer: '15032023-134927-0619',
  ugandaDomesticCustomerNotVATRegistered: '15032023-135211-2395',
  ugandaDomesticPerson: '15112022-171246-0002',
  ugandaForeignCustomer: '17012019-163927-0003',
  ugandaForeignPerson: '15112022-171246-0003',
  ugandaPassportNumber: '15112022-171246-0004',
  ugandaVATnumberLabel: '14032023-084443-1021',
  ugandaPassportTooltipLabel: '29032023-130110-1409',

  serbiaLocalCompany: '25072023-151819-0002',
  serbiaLocalCompanyNonRegistered: '25072023-151819-0001',
  serbiaPrivatePerson: '25072023-151819-0003',
  serbiaForeignCompany: '21012020-151034-0041',
  serbiaForeignPrivatePerson: '10032021-154104-6575',

  romaniaDomesticCompanyTaxRegistered: '19122024-082127-0720',
  romaniaDomesticCompanyNotTaxRegistered: '19122024-082304-8144',
  romaniaDomesticIndividualTaxRegistered: '14112024-110329-6259',
  romaniaDomesticIndividualNotTaxRegistered: '14112024-105931-0572',
  romaniaForeignIndividualEU: '01122023-085002-0004',
  romaniaForeignIndividualNON_EU: '26062024-164700-7968',
  romaniaForeignCompanyEU: '01122023-085002-0003',
  romaniaForeignCompanyNON_EU: '26062024-164736-6642',

  malaysiaDomesticCustomerTaxRegistered: '26062024-164425-4522',
  malaysiaDomesticCustomerNotTaxRegistered: '26062024-164623-8622',
  malaysiaDomesticIndividualTaxRegisteredMK: '06032025-130049-0000',
  malaysiaDomesticIndividualTaxRegisteredMT: '06032025-130049-0001',
  malaysiaDomesticIndividualNotTaxRegisteredMK: '06032025-130049-0002',
  malaysiaDomesticIndividualNotTaxRegisteredMT: '06032025-130049-0003',
  malaysiaForeignCompany: '21012020-151034-0041',
  malaysiaForeignIndividualPassport: '06032025-130049-0004',
  malaysiaGovernment: '18102024-073025-6372',

  israelDomesticCompanyVATRegistered: '19092025-131239-0005',
  israelDomesticCompanyNotVATRegistered: '19092025-131239-0004',
  israelDomesticIndividualVATRegistered: '19092025-131239-0010',
  israelDomesticIndividualNotVATRegistered: '19092025-131239-0009',
  israelForeignIndividual: '21012020-151034-0042',
  israelForeignCompany: '21012020-151034-0041',
  israelGovernmentVATRegistered: '19092025-131239-0008',
  israelGovernmentNotVATRegistered: '19092025-131239-0007',

  VATRegisteredCompaniesWarningSerbia: '25072023-151819-0007',
  foreignRegisteredCustomersWarningSerbia: '14082023-142118-2975',

  malaysiaDomesticAddressWarning: '19022025-110142-0000',
  domesticAddressWarning: '19022025-110142-0000',

  // Existing Customer warnings, country & FS mismatch
  VATRegisteredCompaniesWarningExistingCustomer: '03062024-081001-0003',
  foreignRegisteredCustomersWarningExistingCustomer: '03062024-081001-0002',

  foreignRegisteredCustomersWarning: '16072024-080209-0010',
  domesticTAXRegisteredCustomersWarning: '16072024-080209-0011',

  foreignCustomersMustHave: '16072024-080209-0010',
  domesticCompaniesAndIndividualsMustHave: '19022025-110142-0000',

  customersRegisteredOutsideLocalJurisdiction: '07062024-145156-0000',
  foreignCompaniesRegisteredForVAT: '07062024-145156-0001',

  foreignCompanyFiscalStatus: '21012020-151034-0041',
  foreignPrivatePersonFiscalStatus: '10032021-154104-6575',

  // UI fields - general
  governorate: '10112021-105223-0009',
  fiscalStatus: '01122021-112529-0013',
  nationalIDNo: '01122021-112529-0003',
  passportNo: '01122021-112529-0004',
  taxOffice: '10032021-153843-9251',
  taxObligation: '26082022-074816-0003',
  municipality: '10112021-105223-0010',
  registrationNumber: '25072023-151819-0005',

  // UI fields - malaysia
  TIN: '03032025-075736-0002',
  BRN: '03032025-075736-0000',
  SST: '03032025-075736-0001',
  myKad: '03032025-075736-0003',
  myTentera: '03032025-075736-0005',
  passportNumber: '15112022-171246-0004',
  malaysiaMunicipality: '23122019-211721-0043',
  // Malaysia error messages
  BRN_Error: '22042025-135852-0000',
  SST_Error: '22042025-135852-0001',
  TIN_Error: '15052026-081732-0029',
  TIN_IG_Error: '22042025-135852-0003',
  myKad_Error: '22042025-135852-0004',
  myTentera_Error: '22042025-135852-0005',

  businessRegistrationNumberPattern: '27102025-142623-5689',
  serviceAndSalesTaxNumberPattern: '27102025-143929-4491',
  taxIdentificationNumberPattern: '15052026-081732-0029',
  taxIdentificationNumberIGPattern: '22042025-135852-0003',
  myKadPattern: '22042025-135852-0004',
  myTenteraPattern: '22042025-135852-0005',

  VAT_9_digits_error: '16012026-130827-0002', // Tax/VAT Number should be 9 digits

  expressCheckout: '05092025-210045-0008',

  // Form section headers
  contactDetails: '14112019-155653-0033',
  billingDetails: '12122016-161414-1319',
  invoicingRequirements: '28102025-085406-0003',
  VATInformation: '28102025-085406-0004',

  forMobileNumbersIncludeAR: '08012026-114219-7410', // For mobile phone numbers, please include a 9 after the area code.
  ifLeftBlankCompanyName: '25032024-131937-0006', // If left blank, we will default to your First and Last Name.",

  optional: '01092022-150301-0020'
};
